import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Gamers que transmiten para 0-3 espectadores y están a punto de rendirse.', 'Creadores que no tienen presupuesto para cámaras o micrófonos caros.', 'Jugadores competitivos que quieren construir una marca personal sólida.', 'Personas que quieren vivir de los videojuegos pero no saben por dónde empezar.'];
  const notForWho = ['Gente que busca fama viral de la noche a la mañana sin esforzarse.', 'Personas que creen que solo por abrir el stream el dinero llegará solo.', 'Streamers que no están dispuestos a cambiar su forma de interactuar con el chat.'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0D0D1A] border-y border-gaming-purple/10" data-id="element-2">
      <div className="max-w-6xl mx-auto" data-id="element-3">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-4">
          {/* Who this is for */}
          <div className="bg-gaming-bg border border-gaming-cyan/30 rounded-2xl p-8 box-glow-cyan" data-id="element-5">
            <h3 className="font-orbitron text-2xl font-bold text-white mb-8 flex items-center" data-id="element-6">
              <span className="bg-gaming-cyan/20 text-gaming-cyan p-2 rounded mr-4" data-id="element-7">
                <CheckCircle2 className="w-6 h-6" data-id="element-8" />
              </span>
              Para quién SÍ es
            </h3>
            <ul className="space-y-6" data-id="element-9">
              {forWho.map((item, i) => <li key={i} className="flex items-start" data-id="element-10">
                  <CheckCircle2 className="w-6 h-6 text-gaming-cyan mr-4 flex-shrink-0 mt-0.5" data-id="element-11" />
                  <span className="text-gray-300 leading-relaxed" data-id="element-12">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div className="bg-gaming-bg border border-red-900/30 rounded-2xl p-8" data-id="element-13">
            <h3 className="font-orbitron text-2xl font-bold text-white mb-8 flex items-center" data-id="element-14">
              <span className="bg-red-500/10 text-red-500 p-2 rounded mr-4" data-id="element-15">
                <XCircle className="w-6 h-6" data-id="element-16" />
              </span>
              Para quién NO es
            </h3>
            <ul className="space-y-6" data-id="element-17">
              {notForWho.map((item, i) => <li key={i} className="flex items-start" data-id="element-18">
                  <XCircle className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-19" />
                  <span className="text-gray-400 leading-relaxed" data-id="element-20">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}